import { Route, Routes } from "react-router-dom";
import React from "react";
import { CommercialMonitoringDetail } from "./CommercialMonitoringDetail";
import { CommercialMonitoringDetailReceptionBook } from "./CommercialMonitoringDetailReceptionBook";
import { CommercialMonitoring } from "@/features/commercialRegistrationMonitoring/routes/CommercialMonitoring";
import { CommercialMonitoringUpload } from "@/features/commercialRegistrationMonitoring/routes/CommercialMonitoringUpload";

export const CommercialMonitoringRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="detail/:id"
        element={<CommercialMonitoringDetailReceptionBook />}
      />
      <Route path=":id" element={<CommercialMonitoringDetail />} />
      <Route path="upload" element={<CommercialMonitoringUpload />} />
      <Route path="" element={<CommercialMonitoring />} />
    </Routes>
  );
};
